<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <div class="card">
        <div class="card-body pb-0">
          <div class="row">
            <div class="col-lg-2 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
              <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="filter_string" (ngModelChange)="getItems(); changeQueryParams()" />
            </div>
            <div class="col-lg-2 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
              <ng-select id="figure" [(ngModel)]="filter_figure" [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" (ngModelChange)="getItems(); changeQueryParams()" [placeholder]="'SELECT_FIGURE' | translate">
                <ng-template ng-label-tmp let-item="item">
                  <span>{{ "FIGURE" | translate }} : {{ item }}</span>
                </ng-template>
                <ng-option value="all">{{ "ALL" | translate }}</ng-option>
                <ng-option *ngFor="let dep of _userFigureService.list" [value]="dep.name">{{ dep.name }}</ng-option>
              </ng-select>
            </div>
            <div class="col-xl-2 col-12">
              <ng-select class="w-100" [(ngModel)]="filterYear" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="filterYear && filterYear !== 1" (ngModelChange)="reloadExEmployee()">
                <ng-option [value]="1">
                  <span class="font-small-4 font-weight-normal">{{ "YEAR" | translate | titlecase }}</span>
                </ng-option>
                <ng-option *ngFor="let year of availableYears" [value]="year">
                  <span class="font-small-4 font-weight-normal">{{ year }}</span>
                </ng-option>
              </ng-select>
            </div>
            <div class="col-lg-6 col-12 text-right">
              <div class="w-fit d-inline-block mr-2" *ngIf="!_utilService.isMobile">
                <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
              </div>
              <button has_capability="export_employees_list" class="btn btn-outline-secondary" (click)="export()">{{ "EXPORT_EXCEL" | translate }}</button>
            </div>
          </div>
        </div>
        <div class="card-body px-0 pb-0">
          <!-- tabella desktop -->
          <ngx-datatable
            class="bootstrap core-bootstrap"
            columnMode="force"
            [headerHeight]="50"
            [scrollbarH]="true"
            [rowHeight]="_utilService.isDesktop ? 70 : 160"
            [limit]="tableLimit"
            [footerHeight]="50"
            [rows]="filteredUsers"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate), totalMessage: ('TOTAL' | translate).toLowerCase() }"
            [offset]="pageNumber"
            (page)="setPage($event)"
            [sorts]="[{ prop: 'complete_name', dir: 'asc' }]"
          >
            <ngx-datatable-column [name]="'FIRSTNAME_AND_LASTNAME' | translate" prop="complete_name" [sortable]="true" [width]="250" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <img *ngIf="row.avatar && row.avatar.length > 0" class="rounded-circle mr-1 cover" [src]="row.avatar" height="32" width="32" alt="datatable-avatar" />
                  <div class="avatar bg-light-primary mr-1 ml-0" *ngIf="!row.avatar || row.avatar.length < 1">
                    <div class="avatar-content text-uppercase">{{ row.firstname | initials }}{{ row.lastname | initials }}</div>
                  </div>
                  <div class="cell-line-height">
                    <a routerLink="/dashboard/user/profile/{{ row.hash }}">{{ row.complete_name }}</a>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'BADGE_NUMBER' | translate" prop="number" [sortable]="false" width="170" *ngIf="_authenticationService.hasCapability('view_user_badge_number') && _utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  {{ row.number.split("#")[0] }}<span class="text-primary">#{{ row.number.split("#")[1] }}</span>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'FIGURE' | translate" prop="figure" [sortable]="true" width="190" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <div>{{ row.figure ? row.figure : "-" }}</div>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'CONTRACT_START_DATE' | translate" prop="contract_start_date" [sortable]="true" width="170" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <div>{{ row.contract_start_date | date:"dd/MM/YYYY" }}</div>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'RESIGNATIONS' | translate" prop="end_date" [sortable]="true" width="170" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <div>{{ (row.contract_closed_at || row.contract_end_date) | date:'dd/MM/yyyy' }}</div>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'CITY' | translate" prop="working_city" [sortable]="true" width="110" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <div>{{ row.working_city ? row.working_city : "-" }}</div>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false" *ngIf="_authenticationService.hasCapability('delete_user') && _utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <button (click)="deleteUser(row.hash)" class="text-danger btn border-0">
                  <i [data-feather]="'trash'" size="16" class="mr-50"></i>
                </button>
              </ng-template>
            </ngx-datatable-column>
            <!--mobile - tablet -->
            <ngx-datatable-column [name]="'NAME' | translate" prop="firstname" [sortable]="true" *ngIf="!_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <img *ngIf="row.avatar && row.avatar.length > 0" class="rounded-circle mr-1 cover" src="{{ row.avatar }}" height="70" width="70" alt="datatable-avatar" />
                  <div class="avatar avatar-xl bg-light-primary mr-1 ml-0" *ngIf="!row.avatar || row.avatar.length < 1">
                    <div class="avatar-content text-uppercase">{{ row.firstname | initials }}{{ row.lastname | initials }}</div>
                  </div>
                  <div class="cell-line-height">
                    <a routerLink="/dashboard/user/profile/{{ row.hash }}" class="d-block">{{ row.complete_name }}</a>
                    <div class="mt-025">{{ row.figure ? row.figure : "-" }}</div>
                    <div class="mt-025" *ngIf="_authenticationService.hasCapability('view_user_role')">{{ row.role || "" }}</div>
                    <div class="mt-025">{{ row.working_city ? row.working_city : "-" }}</div>
                    <div class="mt-025">
                      {{ "RESIGNATIONS" | translate }}: {{ row.contract_closed_at ? _utilService.formatDate(row.contract_closed_at) : row.contract_end_date ? _utilService.formatDate(row.contract_end_date) : "" }}
                    </div>
                    <div class="d-flex align-items-center mt-075">
                      <a *ngIf="row.private_phone" [href]="'tel:' + row.private_phone" class="pr-1 text-secondary" [ngbTooltip]="'Chiama al  ' + row.private_phone" placement="left">
                        <i [data-feather]="'phone'" size="22" class="text-success"></i>
                      </a>
                      <a [href]="'mailto:' + row.email" class="text-tertiary pr-1" *ngIf="_authenticationService.hasCapability('generate_branded_cv')">
                        <i [data-feather]="'mail'" size="22"></i>
                      </a>
                      <a routerLink="/dashboard/user/profile/{{ row.hash }}" class="text-info pr-1" ngbTooltip="Visita profilo" placement="left">
                        <i [data-feather]="'file'" size="22"></i>
                      </a>
                      <button (click)="deleteUser(row.hash)" class="text-danger btn border-0" *ngIf="_authenticationService.hasCapability('delete_user')">
                        <i [data-feather]="'trash'" size="16" class="mr-50"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </section>
  </div>
</div>
